import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { selectCurrentUserIsImplementer } from '@ninety/platform/state';

import { surveyRouteNames } from '../_models/survey-route-names.model';

export const canTakeAssessmentGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(selectCurrentUserIsImplementer).pipe(
    take(1),
    map(isImplementer => {
      if (isImplementer) {
        // Redirect implementers to the assessments admin page or my-assessments if they can't access admin
        return router.parseUrl(`/${surveyRouteNames.surveys}/${surveyRouteNames.admin}`);
      }
      return true;
    })
  );
};
